export default __webpack_public_path__ + "static/portfolio-b50eefb041fc2fa7bf74d2ac3de26d9c.jpg";